const BG_IMAGE = 'https://bayshoreofficial.directbooking.sg/assets/additional-background-BrjziagS.jpg';

export default function CTABanner() {
  const scrollToEnquiry = () => {
    document.getElementById('enquiry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[520px] flex items-center overflow-hidden">
      {/* Background Image */}
      <img
        src={BG_IMAGE}
        alt="Vela Bay prime location Bedok Upper East Coast"
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="lazy"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-8 w-full py-14 md:py-20">
        <div className="max-w-2xl space-y-5 md:space-y-6">
          <p className="text-sm font-bold uppercase text-white/70 tracking-widest">
            Limited Units Available!
          </p>
          <h2
            className="text-2xl md:text-4xl font-bold uppercase text-white leading-tight"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Prime Location with Excellent Connectivity in D16 - Bedok / Upper East Coast
          </h2>
          <p
            className="text-xl md:text-2xl font-bold uppercase text-white leading-snug"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Register Your Interest Today!
          </p>
          <p className="text-white/75 text-sm md:text-base">
            Want to be near major expressways or MRTs? Or have the convenience of shops right at
            your doorstep? Look no further!
          </p>
          <div className="flex items-center gap-4 flex-wrap">
            <button
              onClick={scrollToEnquiry}
              className="bg-white text-[#172C37] font-bold px-6 md:px-8 py-3 md:py-4 rounded-lg uppercase text-sm hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Access Now
            </button>
          </div>
          <p className="text-white/50 text-xs">
            *The information is subject to change and photos/images used are for illustration
            purposes only.
          </p>
        </div>
      </div>
    </section>
  );
}
